import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  const [role, setRole] = useState(null); // active role (can be switched for admins)
  const [mustChange, setMustChange] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("omnibat_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        localStorage.setItem("omnibat_user", JSON.stringify(r.data));
        setUser(r.data);
        setRole(localStorage.getItem("omnibat_role") || r.data.role);
        setMustChange(!!r.data.must_change_password);
      })
      .catch((e) => {
        const cached = !e.response && JSON.parse(localStorage.getItem("omnibat_user") || "null");
        if (cached) { setUser(cached); setRole(localStorage.getItem("omnibat_role") || cached.role); } else setUser(false);
      });
  }, []);

  const finish = async (data) => {
    localStorage.setItem("omnibat_token", data.token);
    if (data.device_id) localStorage.setItem("omnibat_device_id", data.device_id);
    localStorage.removeItem("omnibat_role");
    let u = data.user;
    try { const me = await api.get("/auth/me"); u = me.data; } catch (e) { /* keep login user */ }
    localStorage.setItem("omnibat_user", JSON.stringify(u));
    setUser(u);
    setRole(u.role);
    setMustChange(!!(u.must_change_password ?? data.must_change_password));
    return u;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return data.otp_required ? data : finish(data);
  };

  const verifyOtp = async (challenge_id, code) => {
    const { data } = await api.post("/auth/login/verify", { challenge_id, code });
    return finish(data);
  };

  const logout = () => {
    localStorage.removeItem("omnibat_token");
    localStorage.removeItem("omnibat_role");
    localStorage.removeItem("omnibat_user");
    setUser(false);
    setRole(null);
    window.location.href = "/login";
  };

  // super_admin & direction can preview other role dashboards
  const switchRole = (r) => {
    setRole(r);
    localStorage.setItem("omnibat_role", r);
  };

  return (
    <AuthContext.Provider value={{ user, role: role || user?.role, realRole: user?.role, permissions: (user && user.permissions_effective) || {}, setUser, login, verifyOtp, logout, switchRole, mustChange, clearMustChange: () => setMustChange(false) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
